import { IOrganization, IPortal, navStore } from '@mcn-platform/models';
import { viewPortal } from 'components/adminLayout/AdminSideBar';

export const clonePortalAction = {
  name: 'clone',
  label: 'Clone',
  action: (portal: IPortal, navigate: (path: string) => void, store: {
    create: (model: string, a: null, b: null, snap: unknown) => IPortal;
    addStub: (model: string, portal: IPortal) => Promise<{ id: string }>;
    setCurrentPortal: (id: string) => void;
  }) => {
    navStore.showConfirmDialog(
      'Clone Portal',
      'Are you sure you want to make a copy of this portal?',
      () => {
        const newSnap = portal.clone();
        const newPortal = store.create('portal', null, null, newSnap);
        store.addStub('portal', newPortal).then((result) => {
          store.setCurrentPortal(result.id);
          navigate('../details');
        });
      },
      'Make Copy',
      undefined,
      'Cancel',
    );
  },
  disabled: () => false,
};

export const deployPortalAction = {
  name: 'deploy',
  label: 'Deploy',
  action: (portal: IPortal, _navigate: unknown, store: { deployPortal: (p: IPortal) => Promise<void> }) => {
    navStore.showConfirmDialog(
      'Deploy Portal',
      'Are you sure you want to deploy portal to domain {domain}?',
      async () => {
        await store.deployPortal(portal);
      },
      'Deploy Portal',
      undefined,
      'Cancel',
    );
  },
  disabled: () => false,
};

export const viewPortalAction = {
  name: 'view',
  label: 'View',
  action: (portal: IPortal, _navigate: unknown, store: { currentOrganization?: IOrganization }) => {
    if (store.currentOrganization) {
      viewPortal(store.currentOrganization, portal, true);
    }
  },
  disabled: () => false,
};
